import React from 'react'

import { BLOCKS } from '@contentful/rich-text-types'
import clsx from 'clsx'

import { useEventContext } from 'context/EventContext'
import { convertToSlug } from 'helpers/resources'

import classes from './TableOfContent.module.scss'

const TableOfContent = ({ content }) => {
  const { addEvent } = useEventContext({
    name: 'engagement_facet_click',
    engagementComponent: 'resources_article',
  })

  const tableOfContents = content
    .filter(type => type.nodeType === BLOCKS.HEADING_2)
    .map(heading => {
      return {
        value: heading.content[0].value,
      }
    })

  return (
    <div className={clsx('TableOfContent', classes.root)}>
      <h3 className={classes.title}>What we&apos;ll cover</h3>
      <ul>
        {tableOfContents.map(link => {
          const { value } = link
          const slug = convertToSlug(value)
          return (
            <li key={slug}>
              <button
                type="button"
                className="evnt"
                onClick={() => {
                  window.location.href = `#${slug}`
                }}
                {...addEvent({
                  engagementDestination: 'jump-to_article_section',
                  engagementDetails: 'table_of_content-link',
                })}
              >
                {value}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TableOfContent
